import React from 'react';
import styled from 'styled-components';

const StyledMenuRowWrapper = styled.div`
  display: flex;
`;
const StyledMenuRowContent = styled.div`
  flex: 1 1 auto;
  min-height: 0px;
  min-width: 0px;
`;
const StyledMenuRowExtra = styled.div`
  flex: 0 0 auto;
  min-height: 0px;
  min-width: 0px;
`;

export interface RichTextMenuRowProps {
  extra?: React.ReactNode;
  children: React.ReactNode;
}

export function RichTextMenuRow(props: RichTextMenuRowProps) {
  const { extra, children } = props;
  return (
    <StyledMenuRowWrapper>
      <StyledMenuRowContent>{children}</StyledMenuRowContent>
      {extra && <StyledMenuRowExtra>{extra}</StyledMenuRowExtra>}
    </StyledMenuRowWrapper>
  );
}
